import Vue from 'vue'
import VueRouter from 'vue-router'

import Index_Page from '@/views/index.vue';

import CN_Index from '@/views/cn/index.vue';
import CN_MailTo from '@/views/cn/mailto.vue';

import CN_Product from '@/views/cn/product/index.vue';
import CN_ProductDetail from '@/views/cn/product/detail.vue';
import CN_ProductBooking from '@/views/cn/product/booking.vue';
import CN_Recreation from '@/views/cn/recreation/index.vue';
import CN_RecreationDetail from '@/views/cn/recreation/detail.vue';
import CN_RecreationBooking from '@/views/cn/recreation/booking.vue';
import CN_Hotel from '@/views/cn/hotel/index.vue';
import CN_HotelDetail from '@/views/cn/hotel/detail.vue';
import CN_HotelBooking from '@/views/cn/hotel/booking.vue';
import CN_Ticket from '@/views/cn/ticket/index.vue';
import CN_TicketDetail from '@/views/cn/ticket/detail.vue';
import CN_TicketBooking from '@/views/cn/ticket/booking.vue';
import CN_Guide from '@/views/cn/guide/index.vue';
import CN_GuideDetail from '@/views/cn/guide/detail.vue';
import CN_About from '@/views/cn/about/index.vue';
import CN_FaqPage from '@/views/cn/faq/index.vue';
import CN_FaqDetail from '@/views/cn/faq/detail.vue';
import CN_UserLogin from '@/views/cn/user/login.vue';
import CN_UserSign from '@/views/cn/user/sign.vue';
import CN_UserBookingSuccess from '@/views/cn/user/booking_success.vue';
import CN_UserIndex from '@/views/cn/user/index.vue';
import CN_UserOrders from '@/views/cn/user/orders.vue';
import CN_UserOrderDetail from '@/views/cn/user/order_detail.vue';
import CN_UserProtocol from '@/views/cn/user/protocol.vue';
import CN_UserProtocolDetail from '@/views/cn/user/protocol_detail.vue';
import CN_UserCollections from '@/views/cn/user/collections.vue';
import CN_UserProfile from '@/views/cn/user/profile.vue';
import CN_UserResetPassword from '@/views/cn/user/reset_password.vue';
import CN_Search from '@/views/cn/search/index.vue';
import CN_UserPayResult from '@/views/cn/user/pay_result.vue';


import TW_Index from '@/views/tw/index.vue';
import TW_MailTo from '@/views/tw/mailto.vue';
import TW_Product from '@/views/tw/product/index.vue';
import TW_ProductDetail from '@/views/tw/product/detail.vue';
import TW_ProductBooking from '@/views/tw/product/booking.vue';
import TW_Recreation from '@/views/tw/recreation/index.vue';
import TW_RecreationDetail from '@/views/tw/recreation/detail.vue';
import TW_RecreationBooking from '@/views/tw/recreation/booking.vue';
import TW_Hotel from '@/views/tw/hotel/index.vue';
import TW_HotelDetail from '@/views/tw/hotel/detail.vue';
import TW_HotelBooking from '@/views/tw/hotel/booking.vue';
import TW_Ticket from '@/views/tw/ticket/index.vue';
import TW_TicketDetail from '@/views/tw/ticket/detail.vue';
import TW_TicketBooking from '@/views/tw/ticket/booking.vue';
import TW_Guide from '@/views/tw/guide/index.vue';
import TW_GuideDetail from '@/views/tw/guide/detail.vue';
import TW_About from '@/views/tw/about/index.vue';
import TW_FaqPage from '@/views/tw/faq/index.vue';
import TW_FaqDetail from '@/views/tw/faq/detail.vue';
import TW_UserLogin from '@/views/tw/user/login.vue';
import TW_UserSign from '@/views/tw/user/sign.vue';
import TW_UserBookingSuccess from '@/views/tw/user/booking_success.vue';
import TW_UserIndex from '@/views/tw/user/index.vue';
import TW_UserOrders from '@/views/tw/user/orders.vue';
import TW_UserOrderDetail from '@/views/tw/user/order_detail.vue';
import TW_UserProtocol from '@/views/tw/user/protocol.vue';
import TW_UserProtocolDetail from '@/views/tw/user/protocol_detail.vue';
import TW_UserCollections from '@/views/tw/user/collections.vue';
import TW_UserProfile from '@/views/tw/user/profile.vue';
import TW_UserResetPassword from '@/views/tw/user/reset_password.vue';
import TW_Search from '@/views/tw/search/index.vue';
import TW_UserPayResult from '@/views/tw/user/pay_result.vue';


Vue.use(VueRouter)

// 配置路由的数组
const routes = [

	//总首页
	{
		path: '/',
		name: 'Index_Page',
		meta: {
			title: '檀岛旅游'
		},
		component: Index_Page
	},
	
	//邮箱内链接跳转
	{
		path: '/cn/mailto',
		name: 'CN_MailTo',
		meta: {
			title: '檀岛旅游'
		},
		component: CN_MailTo
	},
	
	{
		path: '/cn/',
		name: 'CN_Index',
		meta: {
			title: '檀岛旅游 (简体中文)'
		},
		component: CN_Index
	},
	{
		path: '/cn/product',
		name: 'CN_Product',
		meta: {
			title: '旅游套餐 - 檀岛旅游 (简体中文)'
		},
		component: CN_Product
	},
	{
		path: '/cn/product/detail',
		name: 'CN_ProductDetail',
		meta: {
			title: ''	//套餐详情
		},
		component: CN_ProductDetail
	},
	{
		path: '/cn/product/booking',
		name: 'CN_ProductBooking',
		meta: {
			title: '旅游套餐 | 自助下单 - 檀岛旅游 (简体中文)'
		},
		component: CN_ProductBooking
	},
	
	//玩乐
	{
		path: '/cn/recreation',
		name: 'CN_Recreation',
		meta: {
			title: '景点玩乐 - 檀岛旅游 (简体中文)'
		},
		component: CN_Recreation
	},	
	{
		path: '/cn/recreation/detail',
		name: 'CN_RecreationDetail',
		meta: {
			title: ''	//一日游玩乐
		},
		component: CN_RecreationDetail
	},	
	{
		path: '/cn/recreation/booking',
		name: 'CN_RecreationBooking',
		meta: {
			title: '景点玩乐 | 自助下单 - 檀岛旅游 (简体中文)'
		},
		component: CN_RecreationBooking
	},
	
	//酒店
	{
		path: '/cn/hotel',
		name: 'CN_Hotel',
		meta: {
			title: '酒店 - 檀岛旅游 (简体中文)'
		},
		component: CN_Hotel
	},	
	{
		path: '/cn/hotel/detail',
		name: 'CN_HotelDetail',
		meta: {
			title: ''	//酒店住宿
		},
		component: CN_HotelDetail
	},	
	{
		path: '/cn/hotel/booking',
		name: 'CN_HotelBooking',
		meta: {
			title: '酒店 | 自助下单 - 檀岛旅游 (简体中文)'
		},
		component: CN_HotelBooking
	},	
	
	//门票
	{
		path: '/cn/ticket',
		name: 'CN_Ticket',
		meta: {
			title: '景点门票 - 檀岛旅游 (简体中文)'
		},
		component: CN_Ticket
	},
	{
		path: '/cn/ticket/detail',
		name: 'CN_TicketDetail',
		meta: {
			title: ''	//景点门票
		},
		component: CN_TicketDetail
	},	
	{
		path: '/cn/ticket/booking',
		name: 'CN_TicketBooking',
		meta: {
			title: '景点门票 | 自助下单 - 檀岛旅游 (简体中文)'
		},
		component: CN_TicketBooking
	},	
	
	//攻略
	{
		path: '/cn/guide',
		name: 'CN_Guide',
		meta: {
			title: '攻略 - 檀岛旅游 (简体中文)'
		},
		component: CN_Guide
	},	
	{
		path: '/cn/guide/detail',
		name: 'CN_GuideDetail',
		meta: {
			title: '攻略 - 檀岛旅游 (简体中文)'
		},
		component: CN_GuideDetail
	},
	
	//关于
	{
		path: '/cn/about',
		name: 'CN_About',
		meta: {
			title: '关于我们 - 檀岛旅游 (简体中文)'
		},
		component: CN_About
	},	
	
	
	//FAQ
	{
		path: '/cn/faq',
		name: 'CN_FaqPage',
		meta: {
			title: 'FAQ - 檀岛旅游 (简体中文)'
		},
		component: CN_FaqPage
	},
	{
		path: '/cn/faq/detail',
		name: 'CN_FaqDetail',
		meta: {
			title: 'FAQ - 檀岛旅游 (简体中文)'
		},
		component: CN_FaqDetail
	},
	
	//用户中心
	{
		path: '/cn/user/login',
		name: 'CN_UserLogin',
		meta: {
			title: '登录 - 檀岛旅游 (简体中文)'
		},
		component: CN_UserLogin
	},
	{
		path: '/cn/user/sign',
		name: 'CN_UserSign',
		meta: {
			title: '注册新账户 - 檀岛旅游 (简体中文)'
		},
		component: CN_UserSign
	},
	{
		path: '/cn/user/index',
		name: 'CN_UserIndex',
		meta: {
			title: '我的账户 - 檀岛旅游 (简体中文)'
		},
		component: CN_UserIndex
	},
	{
		path: '/cn/user/orders',
		name: 'CN_UserOrders',
		meta: {
			title: '订单中心 - 檀岛旅游 (简体中文)'
		},
		component: CN_UserOrders
	},
	{
		path: '/cn/user/order_detail',
		name: 'CN_UserOrderDetail',
		meta: {
			title: '订单详情 | 订单中心 - 檀岛旅游 (简体中文)'
		},
		component: CN_UserOrderDetail
	},
	{
		path: '/cn/user/protocol',
		name: 'CN_UserProtocol',
		meta: {
			title: '协议账单 - 檀岛旅游 (简体中文)'
		},
		component: CN_UserProtocol
	},
	{
		path: '/cn/user/protocol_detail',
		name: 'CN_UserProtocolDetail',
		meta: {
			title: '账单详情 | 协议账单 - 檀岛旅游 (简体中文)'
		},
		component: CN_UserProtocolDetail
	},
	{
		path: '/cn/user/collections',
		name: 'CN_UserCollections',
		meta: {
			title: '收藏夹 - 檀岛旅游 (简体中文)'
		},
		component: CN_UserCollections
	},
	{
		path: '/cn/user/profile',
		name: 'CN_UserProfile',
		meta: {
			title: '个人信息 - 檀岛旅游 (简体中文)'
		},
		component: CN_UserProfile
	},
	{
		path: '/cn/user/reset_password',
		name: 'CN_UserResetPassword',
		meta: {
			title: '修改密码 - 檀岛旅游 (简体中文)'
		},
		component: CN_UserResetPassword
	},
	{
		path: '/cn/user/booking_success',
		name: 'CN_UserBookingSuccess',
		meta: {
			title: '自助下单 - 檀岛旅游 (简体中文)'
		},
		component: CN_UserBookingSuccess
	},
	{
		path: '/cn/user/pay_result',
		name: 'CN_UserPayResult',
		meta: {
			title: '支付结果通知 - 檀岛旅游 (简体中文)'
		},
		component: CN_UserPayResult
	},	
	
	//搜索
	{
		path: '/cn/search',
		name: 'CN_Search',
		meta: {
			title: '搜索结果 -  (简体中文)'
		},
		component: CN_Search
	},
	
	///*繁体*******************************///////////
	
	{
		path: '/tw/',
		name: 'TW_Index',
		meta: {
			title: '檀島旅遊 (繁體中文)'
		},
		component: TW_Index
	},	
	
	//邮箱内链接跳转
	{
		path: '/tw/mailto',
		name: 'TW_MailTo',
		meta: {
			title: '檀島旅遊 (繁體中文)'
		},
		component: TW_MailTo
	},
	{
		path: '/tw/product',
		name: 'TW_Product',
		meta: {
			title: '旅遊套餐 - 檀島旅遊 (繁體中文)'
		},
		component: TW_Product
	},
	{
		path: '/tw/product/detail',
		name: 'TW_ProductDetail',
		meta: {
			title: ''	//套餐详情
		},
		component: TW_ProductDetail
	},
	{
		path: '/tw/product/booking',
		name: 'TW_ProductBooking',
		meta: {
			title: '旅遊套餐 | 自助下單 - 檀島旅遊 (繁體中文)'
		},
		component: TW_ProductBooking
	},
	
	//玩乐
	{
		path: '/tw/recreation',
		name: 'TW_Recreation',
		meta: {
			title: '景點玩樂 - 檀島旅遊 (繁體中文)'
		},
		component: TW_Recreation
	},	
	{
		path: '/tw/recreation/detail',
		name: 'TW_RecreationDetail',
		meta: {
			title: ''	//一日游玩乐
		},
		component: TW_RecreationDetail
	},	
	{
		path: '/tw/recreation/booking',
		name: 'TW_RecreationBooking',
		meta: {
			title: '景點玩樂 | 自助下單 - 檀島旅遊 (繁體中文)'
		},
		component: TW_RecreationBooking
	},
	
	//酒店
	{
		path: '/tw/hotel',
		name: 'TW_Hotel',
		meta: {
			title: '酒店 - 檀島旅遊 (繁體中文)'
		},
		component: TW_Hotel
	},	
	{
		path: '/tw/hotel/detail',
		name: 'TW_HotelDetail',
		meta: {
			title: ''	//酒店住宿
		},
		component: TW_HotelDetail
	},	
	{
		path: '/tw/hotel/booking',
		name: 'TW_HotelBooking',
		meta: {
			title: '酒店 | 自助下單 - 檀島旅遊 (繁體中文)'
		},
		component: TW_HotelBooking
	},	
	
	//门票
	{
		path: '/tw/ticket',
		name: 'TW_Ticket',
		meta: {
			title: '景點門票 - 檀島旅遊 (繁體中文)'
		},
		component: TW_Ticket
	},
	{
		path: '/tw/ticket/detail',
		name: 'TW_TicketDetail',
		meta: {
			title: ''	//景点门票
		},
		component: TW_TicketDetail
	},	
	{
		path: '/tw/ticket/booking',
		name: 'TW_TicketBooking',
		meta: {
			title: '景點門票 | 自助下單 - 檀島旅遊 (繁體中文)'
		},
		component: TW_TicketBooking
	},	
	
	//攻略
	{
		path: '/tw/guide',
		name: 'TW_Guide',
		meta: {
			title: '攻略 - 檀島旅遊 (繁體中文)'
		},
		component: TW_Guide
	},	
	{
		path: '/tw/guide/detail',
		name: 'TW_GuideDetail',
		meta: {
			title: '攻略 - 檀島旅遊 (繁體中文)'
		},
		component: TW_GuideDetail
	},
	
	//关于
	{
		path: '/tw/about',
		name: 'TW_About',
		meta: {
			title: '關於我們 - 檀島旅遊 (繁體中文)'
		},
		component: TW_About
	},
	
	//FAQ
	{
		path: '/tw/faq',
		name: 'TW_FaqPage',
		meta: {
			title: 'FAQ - 檀島旅遊 (繁體中文)'
		},
		component: TW_FaqPage
	},
	{
		path: '/tw/faq/detail',
		name: 'TW_FaqDetail',
		meta: {
			title: 'FAQ - 檀岛旅游 (繁體中文)'
		},
		component: TW_FaqDetail
	},
	
	//用户中心
	{
		path: '/tw/user/login',
		name: 'TW_UserLogin',
		meta: {
			title: '登錄 - 檀島旅遊 (繁體中文)'
		},
		component: TW_UserLogin
	},
	{
		path: '/tw/user/sign',
		name: 'TW_UserSign',
		meta: {
			title: '註冊新帳戶 - 檀岛旅游 (繁體中文)'
		},
		component: TW_UserSign
	},
	{
		path: '/tw/user/index',
		name: 'TW_UserIndex',
		meta: {
			title: '我的帳戶 - 檀島旅遊 (繁體中文)'
		},
		component: TW_UserIndex
	},
	{
		path: '/tw/user/orders',
		name: 'TW_UserOrders',
		meta: {
			title: '訂單中心 - 檀島旅遊 (繁體中文)'
		},
		component: TW_UserOrders
	},
	{
		path: '/tw/user/order_detail',
		name: 'TW_UserOrderDetail',
		meta: {
			title: '訂單詳情 | 訂單中心 - 檀島旅遊 (繁體中文)'
		},
		component: TW_UserOrderDetail
	},
	{
		path: '/tw/user/protocol',
		name: 'TW_UserProtocol',
		meta: {
			title: '協議賬單 - 檀島旅遊 (繁體中文)'
		},
		component: TW_UserProtocol
	},
	{
		path: '/tw/user/protocol_detail',
		name: 'TW_UserProtocolDetail',
		meta: {
			title: '賬單詳情 | 協議賬單 - 檀島旅遊 (繁體中文)'
		},
		component: TW_UserProtocolDetail
	},
	{
		path: '/tw/user/collections',
		name: 'TW_UserCollections',
		meta: {
			title: '收藏夾 - 檀島旅遊 (繁體中文)'
		},
		component: TW_UserCollections
	},
	{
		path: '/tw/user/profile',
		name: 'TW_UserProfile',
		meta: {
			title: '個人資訊 - 檀島旅遊 (繁體中文)'
		},
		component: TW_UserProfile
	},
	{
		path: '/tw/user/reset_password',
		name: 'TW_UserResetPassword',
		meta: {
			title: '修改密碼 - 檀島旅遊 (繁體中文)'
		},
		component: TW_UserResetPassword
	},
	{
		path: '/tw/user/booking_success',
		name: 'TW_UserBookingSuccess',
		meta: {
			title: '自助下單 - 檀島旅遊 (繁體中文)'
		},
		component: TW_UserBookingSuccess
	},
	{
		path: '/tw/user/pay_result',
		name: 'TW_UserPayResult',
		meta: {
			title: '支付結果通知 - 檀島旅遊 (繁體中文)'
		},
		component: TW_UserPayResult
	},	
	
	//搜索
	{
		path: '/tw/search',
		name: 'TW_Search',
		meta: {
			title: '搜尋結果 - 檀岛旅游 (繁體中文)'
		},
		component: TW_Search
	},
	
]
// 创建路由对象
const router = new VueRouter({
	mode: 'history', // 使用 history 模式
	routes
})

router.beforeEach((to, from, next) => {
	if (to.meta.title) {
		document.title = to.meta.title;
	}
	next();
});

export default router